<!--
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description: 操作管理
 -->
<template>
    <div class="wrap-box">
        <div class="top">
            <el-header class="top-header">
                <div class="header-content">
                    <h3 class="header-content-title">操作管理</h3>
                    <el-button class="header-content-btn" @click="shiftFormShow">
                        <icon name="double-arrow-up" class="svg-icon-btn" v-show="formShow"></icon>
                        <icon name="double-arrow-down" class="svg-icon-btn" v-show="!formShow"></icon>
                    </el-button>
                </div>
            </el-header>
            <div class="top-content" v-show="formShow">
                <el-form
                    ref="form"
                    label-position="left"
                    :model="form"
                    label-width="80px"
                    :inline="true"
                >
                    <el-form-item label="编码" prop="name">
                        <el-input v-model="form.name" placeholder="输入名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="名称" prop="url">
                        <el-input v-model="form.url" placeholder="输入名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="菜单" prop="parOperation">
                        <el-select v-model="form.parOperation" placeholder="全部" clearable>
                            <el-option
                                v-for="item in operationList"
                                :value="item.id"
                                :key="item.id"
                                :label="item.name"
                            >{{ item.name }}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="链接" prop="url">
                        <el-input v-model="form.url" placeholder="输入链接" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="top-footer">
                <div class="left-btn">
                    <el-button type="primary" size="small" @click="showDialog()">新增</el-button>
                </div>
                <div class="right-btn">
                    <el-button type="primary" size="small" class="reset-btn" @click="resetForm">重置</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        style="width:70px"
                        @click="loadlist(1)"
                    >查询</el-button>
                </div>
            </div>
        </div>
        <div class="list tab-drive">
            <List
                @showDialog="showDialog"
                @loadlist="loadlist"
                :title="tableTitle"
                ref="OperationList"
            ></List>
        </div>
        <Add
            @hideDialog="hideDialog"
            @closeAddModal="closeAddModal"
            v-show="isShow"
            ref="addOperation"
            :addTitle="addTitle"
        ></Add>
    </div>
</template>
<script>
import List from '@/components/OperationalManagement/List';
import Add from '@/components/OperationalManagement/Add';
export default {
    name: 'OperationalManagement',
    components: {
        List,
        Add
    },
    data () {
        return {
            form: {
                name: '',
                url: '',
                parOperation: ''
            },
            tableTitle: '操作管理列表',
            operationList: [],
            addTitle: '新增操作',
            isShow: false,
            isDelete: false,
            selectLoading: global.loading,
            formShow: true // 查询区域显示
        };
    },
    mounted () {
        this.getAll();
    },
    methods: {
        /**
         * @author: liuc
         * @description: 隐藏弹窗
         * @param {}
         */
        hideDialog () {
            this.isShow = false;
        },
        /**
         * @author: liuc
         * @description:显示新增弹窗
         * @param {id} 新增id
         */
        showDialog (id) {
            this.isShow = true;
            var type = 0;
            this.$refs.addOperation.queryOperationList();
            if (this.isNotNull(id)) {
                this.addTitle = '编辑操作';
                type = 1;
            } else {
                this.addTitle = '新增操作';
            }
            this.$refs.addOperation.open(type, id);
        },
        /**
         * @author: liuc
         * @description: 刷新表格
         * @param {operateType} 判断是否为success
         */
        async closeAddModal (operateType) {
            if (operateType === 'success') {
                // 刷新表格
                await this.$refs.OperationList.loadTableRefresh();
            }
        },
        /**
         * @author: liuc
         * @description: 获取列表数据
         * @param {queryBean} 请求接口参数
         */
        async loadTableData (queryBean) {
            await this.$refs.OperationList.loadTable(queryBean);
        },
        /**
         * @author: liuc
         * @description: 获取所有菜单，用于“父级菜单”
         * @param {}
         */
        async getAll () {
            let response = await this.$api.MenuManagement.getAll();
            this.operationList = response.data;
        },
        /**
         * @author: liuc
         * @description:重置
         * @param {}
         */
        resetForm () {
            this.$refs.form.resetFields();
            this.loadlist(1);
        },
        /**
         * @author: liuc
         * @description: 查询菜单
         * @param {currentPage} 当前页数
         */
        loadlist (currentPage) {
            global.loading.select = true;
            let filters = [];
            let name = this.tableSearchNode(
                'sub.name',
                'like',
                [this.form.name],
                'String'
            );
            let url = this.tableSearchNode(
                'sub.url',
                'like',
                [this.form.url],
                'String'
            );
            filters.push([url]);
            filters.push([name]);
            if (this.isNotNull(this.form.parOperation)) {
                let parentid = this.tableSearchNode(
                    'sub.parentid',
                    'eq',
                    [this.form.parOperation],
                    'String'
                );
                filters.push([parentid]);
            }
            let queryBean = this.buildQueryBean(
                currentPage,
                this.pageSize,
                filters
            );
            this.loadTableData(queryBean);
        },
        /**
         * @author: liuc
         * @description: 判断传入的值是否为空
         * @param {target} 输入的内容
         */
        isNotNull (target) {
            if (target) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @author: liuc
         * @description: 菜单管理查询表单显示隐藏
         * @param {}
         */
        shiftFormShow () {
            if (this.formShow) {
                this.formShow = false;
            } else {
                this.formShow = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ./src/views/OperationalManagement.vue